/**
 * All Permissions for Domain Administrator role
 */
export const ADMINISTRATOR_PERMISSIONS: string[] = [
  // 'dashboardView',

  // 'terminalCreate',
  // 'terminalView',
  // 'terminalDetail',
  // 'terminalEdit',
  // 'terminalConfigure',
  // 'terminalConfigureEditable',
  // 'terminalRemove',
  // 'terminalAssign',
  //
  // 'terminalBulkTemplateApply',
  //
  // 'terminalActionRestart',
  // 'terminalActionPushConfig',
  // 'terminalActionPullConfig',
  // 'terminalActionResetConfig',
  // 'terminalActionUpgradeConfig',
  // 'terminalActionTerminalType',
  // 'terminalAdvancedEdit',
  // 'terminalTransactions',
  //
  // 'registrationCreate',
  // 'registrationView',
  // 'registrationEdit',
  // 'registrationFinalize',
  // 'registrationCancel',
  // 'registrationTRF',
  // 'registrationDeactivate',
  // 'registrationRemove',
  //
  // 'transactionView',
  //
  // 'eventView',
  // 'deliveryCreate',
  //
  // 'assetView',
  'administrationView',
  'domainView',
  'domainCreate',
  'domainEdit',
  'domainRemove',
  'domainContractTypeView',
  'domainContractTypeEdit',
  'domainTerminalTypeView',
  'domainTerminalTypeEdit',
  'domainDataView',
  'domainDataEdit',
  'domainAssetView',
  'domainAssetEdit',

  'roleView',
  'roleCreate',
  // 'roleCreateInheritable',
  'roleEdit',
  'roleRemove',

  'userView',
  'userCreate',
  'userEdit',
  'userRemove',
  'userFeatures',
  'userPasswordRequest',
  'privateNotes',
  'serviceMenu',
  'terminalAuditLog',

  // 'templateView',
  // 'templateCreate',
  // 'templateEdit',
  // 'templateRemove',
  // 'templateConfigurationEdit',
  //
  // 'contractCreate',
  // 'contractView',
  // 'contractEdit',
  // 'contractRemove',
  //
  // 'taskView',
  // 'taskCreate',

  // 'terminalImport',
  // 'editNotes',

  'notificationView',
  'notificationCreate',
  'notificationEdit',
  'notificationRemove',
]
